<template>
  <div data-id="mPower-categories-form">
    <loading v-if="!loaded"></loading>
    <div v-else class="">
      <div class="modal-body-fixed-footer" style="height: calc(100vh - 63px)">
        <div class="p-3 mb-1">
          <b-form-group>
            <template slot="label">
              <label>Category Type</label>
              <i
                class="fas fa-question-circle text-light ml-2"
                v-b-popover.hover="{
                  content:
                    'The category type that this category should be associated wtih.  Category types are a grouping of categories such as product, them, blog etc....'
                }"
              ></i>
            </template>
            <autocomplete-input
              :path="'/categories/category-types'"
              label="name"
              loadOnFocus
              isObject
              track-by="_id"
              :validate="{ required: true }"
              v-model="category.categoryType"
            />
          </b-form-group>
          <div class="form-group">
            <validated-input
              v-model="category.name"
              label="Name"
              @blur="categoryNameBlur"
              :validate="{ required: true }"
              :help-options="{ content: 'Category name which will be displayed on stores.', html: true }"
            />
          </div>
          <div class="form-group">
            <label
              >URL Slug
              <i
                class="fas fa-question-circle text-light ml-2"
                v-b-popover.hover="{
                  content:
                    'Unique slug which creates the URL for this category.  After this is saved it cannot be changed.',
                  html: true
                }"
              ></i
            ></label>
            <input type="text" class="form-control" v-model="category.slug" ref="slug" />
          </div>

          <b-form-group>
            <template slot="label">
              <label>Parent Category</label>
              <i
                class="fas fa-question-circle text-light ml-2"
                v-b-popover.hover="{
                  content:
                    'The parent category that this category should be associated with.  Categories can only have one parent category.'
                }"
              ></i>
            </template>
            <autocomplete-input
              :path="`/categories/all?categoryType=${category.categoryType?._id}&excludeParent=${category?._id}&${
                (storeId && `storeId=${storeId}`) || ''
              }`"
              label="name"
              placeholder="Choose Parent Category"
              loadOnFocus
              isObject
              track-by="_id"
              v-model="category.parentCategory"
            >
              <template slot="option" slot-scope="props">
                <span>
                  <i v-if="props.option.isGlobal" class="fas fa-globe mr-2"></i>
                  {{ props.option.name }}
                </span>
              </template>
              <template slot="singleLabel" slot-scope="props">
                <span>
                  <i v-if="props.option.isGlobal" class="fas fa-globe mr-2"></i>
                  {{ props.option.name }}
                </span>
              </template>
            </autocomplete-input>
          </b-form-group>
          <div class="mb-3">
            <b-button @click="more = !more" variant="link" data-id="Advanced options" block>Advanced options</b-button>
          </div>

          <div class="collapse" :class="{ show: more }">
            <div class="form-group">
              <label
                >Description<i
                  class="fas fa-question-circle text-light ml-2"
                  v-b-popover.hover="{
                    content: 'Description of the category which can be used for marketing or display purposes.'
                  }"
                ></i
              ></label>
              <textarea class="form-control" name="description" v-model="category.description"></textarea>
            </div>
            <validated-input
              v-model="category.keywords"
              label="Keywords"
              :name="`keywords`"
              :help-options="{
                content: 'Use these keywords when search for a category or products assigned to that category',
                html: true
              }"
              class="mr-2"
            />

            <b-form-group label="Child Categories" class="disabled">
              <autocomplete-input
                :path="`/categories/all?categoryType=${category.categoryType?._id}&excludeChildren=${
                  category.parentCategory?._id || category?._id
                }&${(storeId && `storeId=${storeId}`) || ''}`"
                label="name"
                placeholder="Choose Parent Category"
                loadOnFocus
                isObject
                :multiple="true"
                track-by="_id"
                v-model="category.childCategories"
              />
            </b-form-group>
            <b-form-group>
              <template slot="label">
                <label>Related Categories</label>
                <i
                  class="fas fa-question-circle text-light ml-2"
                  v-b-popover.hover="{
                    content: 'Categories related with to category.  Categories can relate to one or many categories.'
                  }"
                ></i>
              </template>
              <autocomplete-input
                :path="`/categories/all?categoryType=${category.categoryType?._id}&exclude=${category?._id}&${
                  (storeId && `storeId=${storeId}`) || ''
                }`"
                label="name"
                placeholder="Choose Parent Category"
                loadOnFocus
                isObject
                :multiple="true"
                track-by="_id"
                v-model="category.relatedCategories"
              />
            </b-form-group>

            <b-form-group v-if="canManageStores && !category.isGlobal">
              <autocomplete-input
                :path="storeLink"
                :label="'storeName'"
                :name="'Assign to Stores'"
                loadOnFocus
                :isObject="true"
                :optionsV="category.stores"
                :track-by="'_id'"
                :multiple="true"
                v-model="category.stores"
                :defValue="category.stores"
                v-validate="'required'"
                :help-options="{
                  content: 'Stores associated with this category.',
                  html: true
                }"
              >
                <template slot="option" slot-scope="props">
                  {{ props.option.storeName }}
                </template>
                <template slot="singleLabel" slot-scope="props">
                  {{ props.option.storeName }}
                </template>
              </autocomplete-input>
              <div class="invalid-feedback d-block" v-if="errors.first('stores')">
                {{ errors.first('stores') }}
              </div>
            </b-form-group>

            <b-form-group v-if="store">
              <autocomplete-input
                :path="`/stores/${store}/roles`"
                :label="'name'"
                :name="'Store roles'"
                loadOnFocus
                :isObject="true"
                :optionsV="category.storeRoles"
                :track-by="'_id'"
                :multiple="true"
                v-model="category.storeRoles"
                :help-options="{
                  content:
                    'If has at least one role store page with this category will be restricted for customers with same role only',
                  html: true
                }"
              />
            </b-form-group>

            <b-form-group>
              <b-form-checkbox v-model="category.isHideInMenu">
                Hide In Menu
                <i
                  class="fas fa-question-circle text-light ml-2"
                  v-b-popover.hover="{
                    content:
                      'Hide this category in Megamenu and Navbar components',
                    html: true
                  }"
                ></i>
              </b-form-checkbox>
            </b-form-group>

            <b-form-group v-if="canManageStores">
              <b-form-checkbox v-model="category.isGlobal" v-if="canManageGlobalCategory">
                Global Category
                <i
                  class="fas fa-question-circle text-light ml-2"
                  v-b-popover.hover="{
                    content:
                      'Allow this category to be used globally across all stores that have Global Categories enabled',
                    html: true
                  }"
                ></i>
              </b-form-checkbox>
            </b-form-group>

            <b-form-group v-if="canManageStores">
              <b-form-checkbox v-model="category.isExclude"
                >Exclude from stores<i
                  class="fas fa-question-circle text-light ml-2"
                  v-b-popover.hover="{
                    content:
                      'Allow this category to be used globally across all stores that have Global Categories enabled',
                    html: true
                  }"
                ></i
              ></b-form-checkbox>
            </b-form-group>
            <div class="mt-3 mb-3">
              <label>Preview Image</label>
              <UploadButton
                v-model="tempImage"
                :multiple="false"
                :hasImageType="false"
                :folder="`categories/${category._id}/designs`"
                resize="300"
              />
            </div>
            <div class="card p-3" v-if="canManageGlobalCategory">
              <h5>Google Merchant Center</h5>

              <div class="form-group">
                <label
                  >Google Shopping Category ID
                  <i
                    class="fas fa-question-circle text-light ml-2"
                    v-b-popover.hover="{
                      content: 'Category ID provided by google that most closely relates to this cateogry.',
                      html: true
                    }"
                  ></i
                ></label>
                <input type="text" class="form-control" v-model="category.googleShoppingID" />
              </div>
              <div class="form-group">
                <label
                  >Google Shopping Category Name<i
                    class="fas fa-question-circle text-light ml-2"
                    v-b-popover.hover="{
                      content: 'Path of category provided by google.  Example: Category > Sub Category > etc...',
                      html: true
                    }"
                  ></i
                ></label>
                <input type="text" class="form-control" v-model="category.googleShoppingName" />
              </div>
              <b-form-group v-if="canManageStores">
                <b-form-checkbox v-model="category.isExcludeFromFeed">
                  Exclude from product feeds
                  <i
                    class="fas fa-question-circle text-light ml-2"
                    v-b-popover.hover="{
                      content:
                        'Globally remove this supplier from being published in product feeds for all distributors.',
                      html: true
                    }"
                  ></i
                ></b-form-checkbox>
              </b-form-group>
            </div>
            <div class="card p-3">
              <h5>Category Part Dimensions</h5>
              <DimensionsInputs @onInput="(e) => (category.dimension = e)" :dimension="category?.dimension" />
            </div>
            <div class="mt-3 w-100">
              <PopulateShippingDimensions
                :category="category"
                @select="selectDimension"
                :title="'Part Dimensions'"
                :path="'/average-part-dimension'"
              />
            </div>
            <array-card
              v-if="category.categoryType && category.categoryType.slug === 'products'"
              v-model="category.shippingPackages"
              heading="Shipping Packages"
              :default-item="{ quantity: null, weight: null, depth: null, width: null, height: null }"
              class="my-3 card card-body"
              :headingClass="'h5'"
            >
              <template v-slot:default="props">
                <div class="form-inline">
                  <validated-input
                    v-model="props.item.quantity"
                    label="Quantity"
                    :name="`quantity`"
                    validate="required|numeric|max_value:100000"
                    mask="######"
                    class="mr-2"
                  />
                  <validated-input
                    v-model="props.item.weight"
                    label="Weight (lb)"
                    validate="required|decimal:2|max_value:1000"
                    class="mr-2"
                  />
                  <validated-input
                    v-model="props.item.depth"
                    label="Depth (inches)"
                    validate="required|decimal:2|max_value:1000"
                    class="mr-2"
                  />
                  <validated-input
                    v-model="props.item.width"
                    label="Width (inches)"
                    validate="required|decimal:2|max_value:1000"
                    class="mr-2"
                  />
                  <validated-input
                    v-model="props.item.height"
                    label="Height (inches)"
                    validate="required|decimal:2|max_value:1000"
                    mask="####"
                    class="mr-2"
                  />
                  <validated-input
                    @blur="() => priceChanged(props.item, ['flatRateMargin', 'flatRateCost', 'flatRatePrice'])"
                    v-model="props.item.flatRateCost"
                    label="Cost"
                    validate="decimal"
                    class="mr-2"
                  />
                  <validated-input
                    @blur="() => priceChanged(props.item, ['flatRateMargin', 'flatRateCost', 'flatRatePrice'])"
                    v-model="props.item.flatRatePrice"
                    label="Price"
                    validate="decimal"
                    class="mr-2"
                  />
                  <validated-input
                    append="%"
                    @blur="() => marginChanged(props.item, ['flatRatePrice', 'flatRateCost', 'flatRateMargin'])"
                    v-model="props.item.flatRateMargin"
                    label="Margin"
                    validate="numeric|min:0|max:100"
                    class="mr-2"
                  />
                  <div class="mt-3 w-100">
                    <PopulateShippingDimension :category="category" @change="(d) => Object.assign(props.item, d)" />
                  </div>
                </div>
              </template>
            </array-card>
            <div class="mt-3 w-100">
              <PopulateShippingDimensions :category="category" @select="select" />
            </div>
          </div>
          <div v-if="errors.any()" class="alert alert-danger m-0">
            <div v-for="error in errors.all()">{{ error }}</div>
          </div>
        </div>
      </div>
      <div
        class="modal-fixed-footer card-footer text-right bg-white d-flex align-items-center justify-content-end"
        style="z-index: 1"
      >
        <button type="button" :disabled="loading || errors.any()" class="btn btn-primary" @click="submitForm">
          <i v-if="loading" class="far fa-spinner-third fa-spin"></i> Save Category
        </button>
        <a @click="$emit('close')" class="btn btn-link mr-2" v-if="baseCategory._id || modalMode">Cancel</a>
        <router-link to="/admin/categories" class="btn btn-link mr-2" v-else>Cancel</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import storeFilters from '@/mixins/store.filters.mixin';
import PopulateShippingDimension from './PopulateShippingDimension';
import Autocomplete from '../../../components/Autocomplete';
import priceMarginMixin from '../../../mixins/priceMarginMixin';

export default {
  inject: ['$validator'],
  mixins: [storeFilters, priceMarginMixin],
  components: {
    Autocomplete,
    PopulateShippingDimension,
    PopulateShippingDimensions: () => import('./PopulateShippingDimensions'),
    UploadButton: () => import('@/components/UploadButton'),
    AutocompleteNew: () => import('@/components/Autocomplete'),
    DimensionsInputs: () => import('./DimensionsInputs.vue')
  },
  data() {
    return {
      more: null,
      loaded: false,
      category: {
        relatedCategories: [],
        allChildren: [],
        childCategories: [],
        stores: [],
        dimension: {
          weight: null,
          width: null,
          height: null,
          depth: null
        }
      },
      categoryTypes: [],
      tempImage: [],
      storesForGlobalCategories: [],
      categories: [],
      loading: false,
      submitted: false,
      pageType: this.baseCategory._id ? 'Edit' : 'Create'
    };
  },
  props: {
    categoryList: Array,
    categoryType: Object,
    modalMode: Boolean,
    baseCategory: {
      type: Object,
      default: () => ({})
    },
    canManageStores: {
      type: Boolean,
      default: true
    },
    canManageGlobalCategory: {
      type: Boolean,
      default: true
    },
    colClass: {
      type: String,
      default: () => ''
    }
  },
  // watch: {
  //   async 'category.isGlobal'(val) {
  //     if (val && !this.storesForGlobalCategories.length) this.storesForGlobalCategories = await this.globalStores();
  //     this.storesForGlobalCategories.forEach((i) => {
  //       const storeInIndex = this.category.stores.findIndex((j) => j._id === i._id);
  //       if (val && storeInIndex < 0) this.category.stores.push(i);
  //       else if (!val && storeInIndex > -1) this.category.stores.splice(storeInIndex, 1);
  //     });
  //   }
  // },
  computed: {
    storeId() {
      return this.$route.params?.storeId || this.$route.query?.storeId;
    }
  },
  async mounted() {
    const catId = this.baseCategory._id || this.$route.params.categoryId;

    if (catId) {
      this.category = (
        await this.http.get(`/categories/${catId}?withCategoryType=1&withParent=1&withChildren=1&withRelated=1`)
      ).data;
      if (!this.category.shippingPackages) this.$set(this.category, 'shippingPackages', []);
      this.categories = this.categories.filter((i) => i._id !== catId);
    } else {
      this.category = {
        ...this.category,
        ...this.baseCategory
      };
    }
    this.tempImage = this.category?.image ? [this.category.image] : [];
    this.loaded = true;
  },
  methods: {
    ...mapActions('checklist', ['reloadChecklist']),
    select(newPackage) {
      this.category.shippingPackages.push({ ...newPackage, isPopulated: true });
    },
    selectDimension(row) {
      if (!this.category.dimension) {
        this.$set(this.category, 'dimension', {});
      }
      this.$set(this.category.dimension, 'depth', row.depth);
      this.$set(this.category.dimension, 'height', row.height);
      this.$set(this.category.dimension, 'width', row.width);
      this.$set(this.category.dimension, 'weight', row.weight);
    },
    categoryNameBlur() {
      if (!this.category.slug) {
        this.$refs.slug.value = _.kebabCase(this.category.name);
        this.category.slug = _.kebabCase(this.category.name);
      }
    },
    async submitForm() {
      this.submitted = true;
      await this.$validator.validateAll();
      if (
        this.errors.any() ||
        (!this.category.isGlobal && !this.category.stores?.length) ||
        !this.category.categoryType?._id
      ) {
        this.submitted = false;
        this.notifyError('Please fill all required fields');
        return;
      }

      this.loading = true;
      const categoryModel = { ...this.category };
      categoryModel.image = this.tempImage.length > 0 ? { ...this.tempImage[0] } : null;
      categoryModel.relatedCategories = this.category.relatedCategories.map((cat) => cat._id);
      if (!this.category._id) {
        const { model } = (
          await this.http.post(`/stores/${this.storeId}/categories`, {
            ...categoryModel,
            stores: categoryModel.stores.map((el) => (typeof el === 'string' ? el : el._id)),
            categoryType: categoryModel.categoryType._id
          })
        ).data;
        this.category._id = model._id;
        this.reloadChecklist();
        if (!this.modalMode) {
          this.$router.push('/admin/categories');
        }
      } else {
        await this.http.put(`/categories/${this.category._id}`, {
          ...categoryModel,
          stores: categoryModel.stores.map((el) => (typeof el === 'string' ? el : el._id)),
          categoryType: categoryModel.categoryType._id
        });
      }
      this.$emit('close', this.category);
      this.loading = false;
    }
  }
};
</script>
